export default __webpack_public_path__ + "static/media/icons-system-chevron-left-disabled.4067f1a2.svg";